import {
    CashReceiptIssueType,
    CashReceiptIssueTypeType,
    CashReceiptIssueUsage,
    ReceiptAdditionalPolicy,
} from '@web/core/constants'
import makeSlice from '@web/slices/cashReceipt/sliceMaker'

import {initOrderSheetByAPI} from '../../actions'
import {CashReceipt} from '../../apis/interface/response/interface'

function getIssueNumber(type: Maybe<CashReceiptIssueTypeType>, info: CashReceipt): string[] {
    switch (type) {
        case CashReceiptIssueType.PR_CELL_PHONE_NUMBER:
            return [
                info.mobilePhoneNumberFirst ?? '',
                info.mobilePhoneNumberSecond ?? '',
                info.mobilePhoneNumberThird ?? '',
            ]
        case CashReceiptIssueType.PR_CASH_RECEIPT_CARD_NUMBER:
            return [
                info.cashReceiptCardNumberFirst ?? '',
                info.cashReceiptCardNumberSecond ?? '',
                info.cashReceiptCardNumberThird ?? '',
                info.cashReceiptCardNumberFourth ?? '',
            ]
        case CashReceiptIssueType.BUSINESS_REGISTRATION_NUMBER:
            return [
                info.businessRegistrationNumberFirst ?? '',
                info.businessRegistrationNumberSecond ?? '',
                info.businessRegistrationNumberThird ?? '',
            ]
        default:
            return ['', '', '']
    }
}

const slice = makeSlice({
    extraReducers(builder) {
        builder.addCase(initOrderSheetByAPI.fulfilled, (state, {payload: {purchaser, saleChannelInfo}}) => {
            const {cashReceipt} = purchaser
            const {isCheckout, isEasyBookingGroup} = saleChannelInfo

            // 이전 발행기록이 있을경우 saved에 이전발행유형 저장
            state.issueType.saved = cashReceipt?.issueNumber ? cashReceipt.usageType : null

            state.issueType.current = cashReceipt?.useCashReceipt
                ? (cashReceipt?.issueType ?? CashReceiptIssueType.PR_CELL_PHONE_NUMBER)
                : null

            if (isCheckout || isEasyBookingGroup) {
                state.receiptPolicy = [ReceiptAdditionalPolicy.NFC_PREPAID]
            }

            state.isEdit = !cashReceipt?.issueType
            // 제거된 주민번호 유형으로 내려올 경우 대응
            if (cashReceipt?.issueType === CashReceiptIssueType.PR_SOCIAL_NUMBER) {
                state.issueType.current = CashReceiptIssueType.PR_CELL_PHONE_NUMBER
                state.isEdit = true
                state.issueType.saved = null
            }
            // 이전발행유형이 개인일경우 최근선택한 하위유형에 저장
            if (cashReceipt?.usageType === CashReceiptIssueUsage.PERSONAL_INCOME_TAX) {
                state.issueType.prev = cashReceipt?.issueType ?? CashReceiptIssueType.PR_CELL_PHONE_NUMBER
            }
            if (cashReceipt?.issueType && cashReceipt?.issueType !== CashReceiptIssueType.PR_SOCIAL_NUMBER) {
                state.issueNumber[cashReceipt.issueType] = getIssueNumber(cashReceipt?.issueType, cashReceipt)
            }
        })
    },
})

export default slice.reducer
